import { API_BASE } from "./util";

export interface OrganizationSummary {
  organizationId: string;
  name: string;
}

interface ListOrganizationsResponse {
  organizations: OrganizationSummary[];
}

export interface CreateOrganizationResponse {
  id: string;
}

export async function getOrganizations(
  getToken: () => Promise<string | null>,
): Promise<ListOrganizationsResponse> {
  const token = await getToken();
  const res = await fetch(`${API_BASE}/organizations`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    throw new Error(`Failed to fetch organizations: ${res.status}`);
  }
  return res.json();
}

export async function createOrganization(
  getToken: () => Promise<string | null>,
  name: string,
): Promise<CreateOrganizationResponse> {
  const token = await getToken();
  const res = await fetch(`${API_BASE}/organizations`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name }),
  });
  if (!res.ok) {
    throw new Error(`Failed to create organization: ${res.status}`);
  }
  return res.json();
}
